import { IRuleGroup, TRuleGroup } from "../../../model/evaluation/RuleGroup";
import { IRuleGroupElement } from "../../../model/evaluation/RuleGroupElement";

export interface TRuleGroupPresentationModel extends TRuleGroup {
  selectedElementsIds: string[];
  ruleGroupElements: IRuleGroupElement[];
  elements: IRuleGroupElement[];
}

const RuleGroupPresentationModel = (
  data: IRuleGroup
): TRuleGroupPresentationModel => {
  let _selectedElementsIds: string[] = [];
  let _ruleGroupElements: IRuleGroupElement[] = [];
  let _elements: IRuleGroupElement[] = [];
  return {
    ...data,

    selectedElementsIds: _selectedElementsIds,
    ruleGroupElements: _ruleGroupElements,
    elements: _elements
  };
};

export default RuleGroupPresentationModel;
